import * as React from 'react';
import classnames from 'classnames';
import { motion, AnimatePresence } from 'motion/react';

const defaultPoseConfig = {
    exit: {
        opacity: 0
    },
    enter: {
        opacity: 1
    }
};
/**
 * Consuming components that handle <AnimatePresence> themselves should be able
 * to not have Backdrop wrapped in an <AnimatePresence> component.
 */ const Wrapper = ({ animate , children ,  })=>animate ? /*#__PURE__*/ React.createElement(AnimatePresence, null, children) : /*#__PURE__*/ React.createElement(React.Fragment, null, children)
;
const Backdrop = ({ className , isVisible , onClick , poseConfig =defaultPoseConfig , animate =false ,  })=>/*#__PURE__*/ React.createElement(Wrapper, {
        animate: animate
    }, isVisible && /*#__PURE__*/ React.createElement(motion.div, {
        key: "backdrop",
        className: classnames('backdrop', className),
        role: "presentation",
        onClick: onClick,
        variants: poseConfig,
        initial: "exit",
        animate: "enter",
        exit: "exit"
    }))
;

export { Backdrop as default };
//# sourceMappingURL=Backdrop.js.map
